import FingerprintJS from '@fingerprintjs/fingerprintjs';

export interface BrowserInfo {
  name: string;
  vendor: string;
  version: string;
  online: boolean;
  language: string;
  platform: string;
  userAgent: string;
  cookiesEnabled: boolean;
}

interface DeviceInfo {
  device_id: string;
  browser_info: BrowserInfo;
}

let cachedDeviceInfo: DeviceInfo | null = null;

function getBrowserInfo(): BrowserInfo {
  const userAgent = navigator.userAgent;
  const language = navigator.language;
  const platform = navigator.platform;
  const vendor = navigator.vendor || 'Unknown';
  const online = navigator.onLine;
  const cookiesEnabled = navigator.cookieEnabled;

  let name = 'Unknown';
  let version = 'Unknown';

  // Simple browser detection
  if (/chrome|crios|crmo/i.test(userAgent)) {
    name = 'Chrome';
    version =
      userAgent.match(/(?:chrome|crios|crmo)\/([0-9.]+)/i)?.[1] || 'Unknown';
  } else if (/firefox|fxios/i.test(userAgent)) {
    name = 'Firefox';
    version =
      userAgent.match(/(?:firefox|fxios)\/([0-9.]+)/i)?.[1] || 'Unknown';
  } else if (
    /safari/i.test(userAgent) &&
    !/chrome|crios|crmo/i.test(userAgent)
  ) {
    name = 'Safari';
    version = userAgent.match(/version\/([0-9.]+)/i)?.[1] || 'Unknown';
  } else if (/edg/i.test(userAgent)) {
    name = 'Edge';
    version = userAgent.match(/edg\/([0-9.]+)/i)?.[1] || 'Unknown';
  } else if (/msie|trident/i.test(userAgent)) {
    name = 'Internet Explorer';
    version = userAgent.match(/(?:msie |rv:)([0-9.]+)/i)?.[1] || 'Unknown';
  }

  return {
    name,
    vendor,
    online,
    version,
    language,
    platform,
    userAgent,
    cookiesEnabled,
  };
}

export const getDeviceInfo = async (): Promise<DeviceInfo | null> => {
  try {
    if (cachedDeviceInfo) {
      return cachedDeviceInfo;
    }

    const browser_info = getBrowserInfo();
    const fp = await FingerprintJS.load();
    const { visitorId: device_id } = await fp.get();

    cachedDeviceInfo = {
      device_id,
      browser_info,
    };

    return cachedDeviceInfo;
  } catch (error) {
    console.error('Failed to generate device fingerprint:', error);
    return null;
  }
};
